import RecruitmentTabs from "./RecruitmentSettings/RecruitmentTabs";
import SettingPageLayout from "./SettingPageLayout";

function MainRecruitSettings() {
  return <SettingPageLayout>
    <RecruitmentTabs/>
  </SettingPageLayout>;
}

export default MainRecruitSettings;
